import * as Auth from '../../../pages/auth'
import * as Request from '../../../request'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const initialState: Types.State = {
  isOpen: false,
  user: Constants.NoUser,
}

export const reducer =
  (state: Types.State = initialState, action: Types.ToggleUserMenuAction & Request.SuccessAction) => {
  switch (action.type) {
    case Request.successConstant(Auth.VALIDATE_TOKEN):
      return {
        ...state,
        user: Utils.userFrom(action.payload.response),
      }
    case Constants.TOGGLE_USER_MENU:
      return {
        ...state,
        isOpen: !state.isOpen,
      }
    case Constants.CLICK_OUTSIDE:
      if (state.isOpen) {
        return {
          ...state,
          isOpen: false,
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/user-menu/reducer.ts